import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../../core/services/api.service';
import { PageTitleService } from '../../../core/services/page-title.service';

@Component({
  selector: 'app-search-by-category',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './search-by-category.component.html',
  styleUrl: './search-by-category.component.scss',
})
export class SearchByCategoryComponent implements OnInit {
  view: 'search' | 'books' = 'search';

  searchInput = '';
  categoryResults: any[] = [];
  isLoadingCategories = false;
  hasSearched = false;
  searchError = '';

  selectedCategory: any = null;
  categoryBooks: any[] = [];
  isLoadingBooks = false;
  booksError = '';

  showCopiesModal = false;
  selectedBook: any = null;
  isLoadingCopies = false;
  copiesError = '';

  constructor(private api: ApiService, private pageTitle: PageTitleService) {}

  ngOnInit(): void {
    this.pageTitle.set('Search by Category', 'Find books by category');
  }

  searchCategories(): void {
    const term = this.searchInput.trim();
    this.hasSearched = true;
    this.searchError = '';
    this.categoryResults = [];
    if (term.length < 2) {
      this.searchError = 'Enter at least 2 characters to search.';
      return;
    }
    this.isLoadingCategories = true;
    this.api.getCategories({ search: term }).subscribe({
      next: (data) => {
        this.categoryResults = data || [];
        this.isLoadingCategories = false;
        if (!this.categoryResults.length) {
          this.searchError = 'No categories found matching your search.';
        }
      },
      error: (err: any) => {
        this.searchError = err?.message || 'Failed to load categories. Please try again.';
        this.isLoadingCategories = false;
      },
    });
  }

  selectCategory(category: any): void {
    this.selectedCategory = category;
    this.categoryBooks = [];
    this.booksError = '';
    this.isLoadingBooks = true;
    this.view = 'books';
    this.pageTitle.set('Search by Category', category.categoryName);
    this.api.getBooksByCategory(category.categoryName).subscribe({
      next: (books) => { this.categoryBooks = books || []; this.isLoadingBooks = false; },
      error: (err: any) => { this.booksError = err?.message || 'Failed to load books.'; this.isLoadingBooks = false; },
    });
  }

  backToSearch(): void {
    this.view = 'search';
    this.selectedCategory = null;
    this.pageTitle.set('Search by Category', 'Find books by category');
  }

  viewCopies(book: any): void {
    this.selectedBook = { ...book, copies: null };
    this.isLoadingCopies = true;
    this.copiesError = '';
    this.showCopiesModal = true;
    this.api.getBookCopies(book._id).subscribe({
      next: (copies) => { this.selectedBook.copies = copies || []; this.isLoadingCopies = false; },
      error: (err: any) => { this.copiesError = err?.message || 'Failed to load copies.'; this.isLoadingCopies = false; },
    });
  }

  closeModal(): void {
    this.showCopiesModal = false;
    this.selectedBook = null;
    this.isLoadingCopies = false;
    this.copiesError = '';
  }

  statusLabel(status: string): string {
    if (status === 'C') return 'At Center';
    if (status === 'M') return 'Issued';
    if (status === 'S') return 'Scrapped';
    return status;
  }

  rowClass(status: string): string {
    if (status === 'C') return 'sba-row-center';
    if (status === 'M') return 'sba-row-issued';
    if (status === 'S') return 'sba-row-scrapped';
    return '';
  }
}
